import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import GlobalStyles from "@mui/material/GlobalStyles";
import Button from "@mui/material/Button";
import { useT } from "talkr";
import { alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
//@ts-ignore
import Flag from "react-world-flags";
import Background from "./assets/Background_blue.png";

export default function TeaPage() {
  const { T, setLocale } = useT();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <GlobalStyles
        styles={{
          body: {
            backgroundImage: `url(${Background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            minHeight: "100vh",
          },
        }}
      />

      <Box
        aria-hidden
        sx={{
          position: "fixed",
          inset: 0,
          backgroundColor: alpha("#ffffffff", 0.85),
          zIndex: 0,
          pointerEvents: "none",
        }}
      />

      <Container
        maxWidth="md"
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: { xs: 3, sm: 5, md: 6 },
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontFamily: "FUTURAM",
            fontWeight: 700,
            letterSpacing: { xs: 1, sm: 2, md: 3 },
            mb: { xs: 2, sm: 3, md: 4 },
            textAlign: "center",
            color: "primary.contrastText",
          }}
        >
          {T("tea.title")}
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontFamily: "FUTURAM",
            fontWeight: 600,
            mb: { xs: 1, sm: 2 },
            textAlign: "center",
            color: "primary.contrastText",
          }}
        >
          {T("tea.subtitle")}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: { xs: 2, sm: 3 },
            color: "primary.contrastText",
            textAlign: "center",
            fontSize: { xs: "0.95rem", sm: "1.1rem" },
            lineHeight: 1.8,
            maxWidth: 700,
          }}
        >
          {T("tea.description")}
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontFamily: "FUTURAM",
            fontWeight: 600,
            mt: { xs: 2, sm: 3 },
            mb: { xs: 1, sm: 2 },
            textAlign: "center",
            color: "primary.contrastText",
          }}
        >
          {T("tea.ceremony_title")}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: { xs: 2, sm: 3 },
            color: "primary.contrastText",
            textAlign: "center",
            fontSize: { xs: "0.95rem", sm: "1.1rem" },
            lineHeight: 1.8,
            maxWidth: 700,
          }}
        >
          {T("tea.ceremony_description")}
        </Typography>

        <Typography
          variant="h6"
          sx={{
            fontFamily: "FUTURAM",
            fontWeight: 600,
            mt: { xs: 2, sm: 3 },
            mb: { xs: 1, sm: 2 },
            textAlign: "center",
            color: "primary.contrastText",
          }}
        >
          {T("tea.symbolism_title")}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mb: { xs: 2, sm: 3 },
            color: "primary.contrastText",
            textAlign: "center",
            fontSize: { xs: "0.95rem", sm: "1.1rem" },
            lineHeight: 1.8,
            maxWidth: 700,
          }}
        >
          {T("tea.symbolism_description")}
        </Typography>

        <Button
          variant="outlined"
          onClick={() => navigate("/")}
          sx={{
            mt: { xs: 3, sm: 4 },
            fontFamily: "FUTURAM",
            color: "primary.contrastText",
            borderColor: "primary.contrastText",
            "&:hover": {
              borderColor: "primary.contrastText",
              backgroundColor: alpha("#000000", 0.1),
            },
          }}
        >
          {T("tea.home")}
        </Button>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 2, sm: 3 },
            gap: 1,
          }}
        >
          {[
            { locale: "en", code: "GB" },
            { locale: "tw", code: "TW" },
            { locale: "sk", code: "sk" },
            { locale: "cs", code: "CZ" },
            { locale: "es", code: "CO" },
            { locale: "it", code: "IT" },
            { locale: "el", code: "GR" },
            { locale: "tr", code: "TR" },
          ].map(({ locale, code }) => (
            <IconButton
              key={locale}
              sx={{
                p: { xs: 0.2, sm: 0.5, md: 1 },
                width: { xs: 28, sm: 40, md: 48 },
                height: { xs: 28, sm: 40, md: 48 },
              }}
              onClick={() => setLocale(locale)}
            >
              <Flag
                code={code}
                style={{ width: "100%", height: "100%", objectFit: "contain" as const }}
              />
            </IconButton>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
